import { encodeLut } from './cube';
import { LUT_PRESET_IDS, type LutPresetId } from './types';

export const VIDEO_LUT_PRESETS = LUT_PRESET_IDS.map(id => ({ id, labelKey: `videoEffects.presets.${id}` }));
const cache = new Map<LutPresetId, string>();
/** Original looks, generated in SDR; no third-party LUT assets or licenses. */
export function getPresetLutData(id: LutPresetId): string {
  const existing = cache.get(id);
  if (existing) return existing;
  const data = encodeLut((r, g, b) => {
    const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    switch (id) {
      case 'warm': return [r * 1.06 + 0.02, g * 1.015, b * 0.9];
      case 'cool': return [r * 0.92, g * 1.015, b * 1.06 + 0.015];
      case 'cinema': return [r * 1.08 - 0.03 + luma * 0.02, g * 1.04 + (1 - luma) * 0.015 - 0.025, b * 0.98 + (1 - luma) * 0.05 - luma * 0.025];
      case 'vintage': return [r * 0.87 + 0.08, g * 0.84 + 0.075, b * 0.73 + 0.105];
      case 'vivid': return [r, g, b].map(c => (luma + (c - luma) * 1.25 - 0.5) * 1.08 + 0.5);
      case 'mono': return [luma, luma, luma].map(c => (c - 0.5) * 1.1 + 0.5);
    }
  });
  cache.set(id, data);
  return data;
}
